import { render, staticRenderFns } from "./boxTitle.vue?vue&type=template&id=52e411a1&scoped=true"
import script from "./boxTitle.vue?vue&type=script&lang=js"
export * from "./boxTitle.vue?vue&type=script&lang=js"
import style0 from "./boxTitle.vue?vue&type=style&index=0&id=52e411a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e411a1",
  null
  
)

export default component.exports